import { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Navigate, useParams } from 'react-router'
import { AppRoutes } from '../../app-routes'
import { DialogContextTypes } from '../../enums'
import {
  clearAxiosBoatHeader,
  clearAxiosClientHeader,
  setAxiosBoatHeader,
  setAxiosClientHeader,
} from '../../helpers/AuthorizationHelpers'
import { getAssetTitle } from '../../helpers/utils'
import { useDialogCtx, useMainLayoutContext } from '../../hooks/context-hooks'
import { getAssetById } from '../../http'
import { clearAxiosFeatureValueHeader, setAxiosFeatureValueHeader } from '../../Http/featureHttp'
import { Queries } from '../../queries'
import { IAsset } from '../../types/data-types'
import { CenteredSpinner } from '../Common/Spinner'

export const AssetLayoutContext = createContext<{ asset: IAsset; permission: number; featureValue: bigint }>(undefined)

export const AssetLayoutContextProvider = ({ children }) => {
  const { id: assetId } = useParams<any>()
  const { data: asset, isError } = useQuery([Queries.ASSET, assetId], () => getAssetById(Queries.ASSET, assetId))
  const mainLayoutContext = useMainLayoutContext()

  const [providerValue, setProviderValue] = useState(null)
  const { getDialogs } = useDialogCtx()

  useEffect(() => {
    return () => {
      clearAxiosClientHeader()
      clearAxiosBoatHeader()
      clearAxiosFeatureValueHeader()
      mainLayoutContext?.header?.clear?.()
    }
  }, [mainLayoutContext])

  useEffect(() => {
    if (!!asset && asset != providerValue?.boat) {
      setProviderValue({ asset, permission: asset.permissionValue, featureValue: BigInt(asset?.featureValue) })
      setAxiosClientHeader(asset.clientId)
      setAxiosBoatHeader(asset.assetId)
      setAxiosFeatureValueHeader(asset?.encryptedFeatureValue)

      const assetTitle = getAssetTitle(asset)
      mainLayoutContext?.header?.updateTitle?.(assetTitle)
    }
  }, [asset, mainLayoutContext, providerValue?.boat])
  if (isError) return <Navigate to={AppRoutes.NOT_FOUND} />

  return (
    <AssetLayoutContext.Provider value={providerValue}>
      {Object.values(getDialogs(DialogContextTypes.boat) ?? {})}
      {!providerValue ? <CenteredSpinner /> : children}
    </AssetLayoutContext.Provider>
  )
}
